export default {
    namespaced: true,
    state: {
        filters: {
            platforms: null,
            is_active: null,
            campaigns: null,
            dsps: null,
            nameScope: null
        }
    },
    getters: {
        GET_FILTERS: state => {
            return state.filters
        },
        GET_SEARCH: state => {
            return state.filters.nameScope
        },
        GET_STATE_CHECK : state => {
            return Object.values(state.filters).some(item => item)
        }
    },
    mutations: {
        SET_FILTER: (state, payload) => {
            state.filters[payload.name] = payload.value
        }
    },
    actions: {
        setFilter: (context, payload) => {
            context.commit('SET_FILTER', payload)
        },
        setIsActive: (context, payload) => {
            context.commit('SET_FILTER', { name: 'is_active', value: payload })
        },
        setSearch: (context, payload) => {
            context.commit('SET_FILTER', { name: 'nameScope', value: payload })
        }
    }
}
